import airPriceGuideRequests from './queries/retailQuery'

/**
 * Operation and query Names for all Air Price Guide requests
 * */
const airPriceGuideRequestTypes = {
  APG_EXPRESS_DEAL_OW: 'airPriceGuideExpressDealOW',
  APG_RETAIL_OW: 'airPriceGuideRetailOW',
  APG_EXPRESS_DEAL_RT: 'airPriceGuideExpressDealRT',
  APG_RETAIL_RT: 'airPriceGuideRetailRT',
  APG_NUM_VIEWERS: 'airPriceGuideNumViewers',
}

export function buildAirPriceGuideRequest({ request, tripType, onlyViewers }) {
  let operationName = ''

  if (tripType === 'OW') {
    operationName = request.fareType === 'SOPQ'
      ? airPriceGuideRequestTypes.APG_EXPRESS_DEAL_OW
      : airPriceGuideRequestTypes.APG_RETAIL_OW
  }

  if (tripType === 'RT') {
    operationName = request.fareType === 'SOPQ'
      ? airPriceGuideRequestTypes.APG_EXPRESS_DEAL_RT
      : airPriceGuideRequestTypes.APG_RETAIL_RT
  }

  if (onlyViewers) {
    operationName = airPriceGuideRequestTypes.APG_NUM_VIEWERS
  }

  return {
    operationName,
    variables: { input: request },
    query: airPriceGuideRequests[operationName],
  }
}
